import type { Product } from 'src/models/product/schema';
import styles from './index.module.scss';

import { RankingItem } from 'src/components/shared/products/RankingItem';
import { mixpanel } from 'src/utils/mixpanel';

const handleClick = (product: Product, categorySlug: string) =>
  mixpanel.onRankingProductClicked(categorySlug, product.productId, product.middleCategoryId, product.largeCategoryId);

type Props = {
  products: Product[];
  categorySlug: string;
};

export const RankingList: React.FC<Props> = ({ products, categorySlug }) => {
  return (
    <ul className={styles.container}>
      {products.map((product, index) => (
        <li key={product.productId} onClick={() => handleClick(product, categorySlug)}>
          <RankingItem product={product} index={index} useNewStyles />
        </li>
      ))}
    </ul>
  );
};
